import React from 'react';
import BottomNav from '../components/BottomNav';

const LuxuryTravelConcierge = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Luxury Travel Concierge</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Your Personal Travel Expert</p>
        
        <div className="card">
          <p>
            Dedicated travel concierge services available 24/7. We handle every detail 
            of your journey, from bookings to on-ground support worldwide.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>24/7 Assistance</h3>
              <p>Round-the-clock travel support anywhere in the world</p>
            </div>
            <div className="feature-item">
              <h3>Complete Planning</h3>
              <p>Seamless itineraries with every detail arranged</p>
            </div>
            <div className="feature-item">
              <h3>VIP Services</h3>
              <p>Fast-track immigration, lounge access, and more</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default LuxuryTravelConcierge;
